import { render, staticRenderFns } from "./AIImage.vue?vue&type=template&id=595fdb66&scoped=true"
import script from "./AIImage.vue?vue&type=script&lang=js"
export * from "./AIImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595fdb66",
  null
  
)

export default component.exports